import { render, staticRenderFns } from "./RiskInactive.vue?vue&type=template&id=6aa71cfe"
import script from "./RiskInactive.vue?vue&type=script&lang=js"
export * from "./RiskInactive.vue?vue&type=script&lang=js"
import style0 from "./RiskInactive.vue?vue&type=style&index=0&id=6aa71cfe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports